module.exports = __webpack_public_path__ + "static/img/zhu2.8a65c92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhu2.jpg
// module id = wL4n
// module chunks = 1